(() => {
  const STORAGE_KEY = 'mcor_fit_guide_vehicle_v1';
  const PARAMS = {
    year: 'fg_year',
    make: 'fg_make',
    model: 'fg_model',
    submodel: 'fg_submodel',
    body_style: 'fg_body',
    screen: 'fg_screen',
    amplifier: 'fg_amp',
    hvac: 'fg_hvac',
    key_type: 'fg_key',
    transmission: 'fg_trans',
    powertrain: 'fg_powertrain',
  };

  const readVehicle = () => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const hasVehicle = (vehicle) => Boolean(vehicle?.year && vehicle?.make && vehicle?.model);

  const fitGuideUrl = (root, vehicle) => {
    const url = new URL(root.dataset.fitGuideUrl || '/pages/speaker-fit-guide', window.location.origin);
    Object.entries(PARAMS).forEach(([field, parameter]) => {
      if (vehicle[field]) url.searchParams.set(parameter, vehicle[field]);
    });
    return `${url.pathname}${url.search}`;
  };

  const render = () => {
    const root = document.getElementById('McorVehicleContext');
    if (!root) return;

    const vehicle = readVehicle();
    if (!hasVehicle(vehicle)) {
      root.hidden = true;
      return;
    }

    root.querySelector('[data-mcor-vehicle-label]').textContent = [vehicle.year, vehicle.make, vehicle.model]
      .filter(Boolean)
      .join(' ');

    const details = [vehicle.submodel, vehicle.body_style]
      .filter((value, index, values) => value && values.indexOf(value) === index)
      .join(' • ');
    const detailsElement = root.querySelector('[data-mcor-vehicle-details]');
    detailsElement.textContent = details;
    detailsElement.hidden = !details;

    root.querySelector('[data-mcor-vehicle-change]').href = fitGuideUrl(root, vehicle);
    root.hidden = false;
  };

  document.addEventListener('DOMContentLoaded', render, { once: true });
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) render();
  });
  document.addEventListener('mcor:vehicle-changed', render);
})();
